import { useEffect, useState } from "react";
import { AlertTriangle, CheckCircle2, XCircle } from "lucide-react";
import { errMsg, useApi } from "@/lib/api";

const MOD = { forms: "Moduli", bookings: "Prenotazioni", payments: "Pagamenti", shop: "Negozio" };

// C5: publish readiness of forms, bookings, payments and shop for this site (report only).
export default function ReadinessCard({ site, refreshKey }) {
  const api = useApi();
  const [rep, setRep] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/t/${site.client.id}/sites/${site.id}/readiness`).then(({ data }) => { setRep(data); setErr(""); }).catch((e) => setErr(errMsg(e)));
  }, [api, site.client.id, site.id, refreshKey]);
  if (err) return <p className="text-xs text-red-600" data-testid="readiness-error">Controllo funzioni non disponibile: {err}</p>;
  if (!rep || !rep.modules.length) return null;
  const items = [...rep.errors, ...rep.warnings];
  return (
    <section className={`rounded-xl border px-5 py-4 ${rep.ok ? (rep.warnings.length ? "border-amber-200 bg-amber-50/40" : "border-emerald-200 bg-emerald-50/50") : "border-red-200 bg-red-50/50"}`} data-testid="readiness-card">
      <div className="flex flex-wrap items-center gap-2">
        {rep.ok ? <CheckCircle2 size={17} className="text-emerald-600" /> : <XCircle size={17} className="text-red-600" />}
        <h2 className="text-sm font-semibold text-slate-800" data-testid="readiness-status">
          {rep.ok ? "Funzioni del sito pronte" : `Funzioni del sito: ${rep.errors.length} ${rep.errors.length === 1 ? "problema da risolvere" : "problemi da risolvere"}`}</h2>
        <span className="text-xs text-slate-500">{rep.modules.map((m) => MOD[m]).join(" · ")}</span>
      </div>
      {items.length > 0 && <ul className="mt-2 space-y-1.5" data-testid="readiness-items">{items.map((x, i) => (
        <li key={i} className="flex gap-2 text-xs" data-testid={`readiness-${x.level}-${x.code}`}>
          {x.level === "error" ? <XCircle size={14} className="mt-0.5 shrink-0 text-red-600" /> : <AlertTriangle size={14} className="mt-0.5 shrink-0 text-amber-600" />}
          <span><b className="text-slate-800">{MOD[x.module]}: {x.title}</b>{x.detail ? <span className="text-slate-600"> — {x.detail}</span> : null}</span></li>))}</ul>}
    </section>
  );
}
